import selectors from '../../rootSelectors';
import { dataDogAddWarning } from '../logging/datadog';

import { retriableGetComplete } from './apiCallActions';

import { fetchApplicationData } from '../../AppActions';
import { fetchStudentForms } from './formsActions';
import { fetchTRCContent } from '../../trc/trcActions';
import { fetchVocabTQVMContent } from '../../vocab/tqvm/vocabTQVMActions';
import { fetchVocabFITBContent } from '../../vocab/fitb/vocabFITBActions';
import { fetchVocabBDContent } from '../../vocab/bd/vocabBDActions';
import { fetchRANContent } from '../../ran/ranActions';
import { fetchSpellingContent } from '../../spelling/spellingActions';
import { fetchMazeContent } from '../../maze/mazeActions';
import { fetchWRContent } from '../../wr/wrActions';

import {
    APP_DATA_FETCH_RETRY,
    FORMS_DATA_FETCH_RETRY,
    MAZE_FETCH_RETRY,
    TRCO_FETCH_RETRY,
    VOCAB_TQVM_FETCH_RETRY,
    VOCAB_FITB_FETCH_RETRY,
    VOCAB_BD_FETCH_RETRY,
    SPELLING_FETCH_RETRY,
    RAN_FETCH_RETRY,
    WR_FETCH_RETRY,
    LC_FETCH_RETRY,
    CLPL_FETCH_RETRY,
} from './apiRetryGetConstants';
import { fetchLCContent } from '../../lc/lcActions';
import { fetchCLPLContent } from '../../clpl/clplActions';

export const GET_RETRY_ACTIONS_MAP = {
    [APP_DATA_FETCH_RETRY]: fetchApplicationData,
    [FORMS_DATA_FETCH_RETRY]: fetchStudentForms,
    [TRCO_FETCH_RETRY]: fetchTRCContent,
    [VOCAB_TQVM_FETCH_RETRY]: fetchVocabTQVMContent,
    [VOCAB_FITB_FETCH_RETRY]: fetchVocabFITBContent,
    [VOCAB_BD_FETCH_RETRY]: fetchVocabBDContent,
    [RAN_FETCH_RETRY]: fetchRANContent,
    [SPELLING_FETCH_RETRY]: fetchSpellingContent,
    [MAZE_FETCH_RETRY]: fetchMazeContent,
    [WR_FETCH_RETRY]: fetchWRContent,
    [LC_FETCH_RETRY]: fetchLCContent,
    [CLPL_FETCH_RETRY]: fetchCLPLContent,
};

export const retryGetRequestAction = () => (dispatch, getStore) => {
    const state = getStore();

    const retryGetRequestActionName = selectors.getRetryGetRequestActionName(state);
    if (GET_RETRY_ACTIONS_MAP[retryGetRequestActionName]) {
        dispatch(retriableGetComplete(retryGetRequestActionName));
        dispatch(GET_RETRY_ACTIONS_MAP[retryGetRequestActionName]());
        return;
    }
    // No-op when no retriable GET is awaiting retry (ATEAM-4533). The Retry
    // button in AppErrorView is gated on appLevelErrorStatus, not on
    // retryGetRequestActionName, so it can be shown after non-GET failures
    // (POST/PATCH during a GET-in-flight window) or in the brief gap after a
    // successful retry. Throwing here turned a harmless invalid-state click
    // into a RUM error event; the warning preserves observability.
    dataDogAddWarning('Invalid retryGetRequestActionName', { retryGetRequestActionName });
};
